import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '@welldev-group/rcl-icon';
import IconButton from '@welldev-group/rcl-icon-button';
import '../../styles.scss';

export default function FilterTags({ onRemoveFilter, currentFilters }) {
  const [showAllTags, setShowAllTags] = useState(false);
  const ACTIVE_FILTER_LIMIT = 3;

  const filterOutNullData = (res, obj, key) => {
    res[key] = obj[key];
    return res;
  };

  Object.filter = (obj, predicate) =>
    Object.keys(obj)
      .filter(key => predicate(obj[key]))
      .reduce((res, key) => filterOutNullData(res, obj, key), {});

  const selectedFilters = Object.filter(currentFilters, currentFilter => currentFilter !== null);
  const taggedFilters = Object.keys(selectedFilters);

  const showHideTags = () => {
    setShowAllTags(!showAllTags);
  };

  return (
    <div>
      {taggedFilters.length > 0 ? (
        <div className="hotel-results__active">
          <div className="hotel-results__active--heading">
            {I18n.t('components.ibe.search_results.filters.active_filters')}
          </div>
          <span className="hotel-result__active-tag">
            {!showAllTags
              ? taggedFilters.slice(0, ACTIVE_FILTER_LIMIT).map(tag => (
                  <span className="hotel-results__tag">
                    <span>{selectedFilters[tag]}</span>
                    <IconButton
                      icon={<Icon name="close" size="tiny" />}
                      isIconOnly={true}
                      onClick={() => onRemoveFilter(tag)}
                    />
                  </span>
                ))
              : taggedFilters.map(tag => (
                  <span className="hotel-results__tag">
                    <span>{selectedFilters[tag]}</span>
                    <IconButton
                      icon={<Icon name="close" size="tiny" />}
                      isIconOnly={true}
                      onClick={() => onRemoveFilter(tag)}
                    />
                  </span>
                ))}
            {taggedFilters.length > ACTIVE_FILTER_LIMIT && (
              <span role="presentation" onClick={showHideTags} className="hotel-results__show-hide">
                {!showAllTags
                  ? I18n.t('components.ibe.search_results.filters.tagged_items', {
                      items: taggedFilters.length - ACTIVE_FILTER_LIMIT,
                    })
                  : I18n.t('components.ibe.search_results.filters.hide_tags')}
              </span>
            )}
          </span>
          <div className="hotel-results__horizontal-line--active-filter">
            <hr />
          </div>
        </div>
      ) : null}
    </div>
  );
}

FilterTags.propTypes = {
  onRemoveFilter: PropTypes.func.isRequired,
  currentFilters: PropTypes.objectOf(PropTypes.shape([])).isRequired,
};
